import * as OvationsApi from 'core/ovations-api';
import { ClaimStatus, ReconciliationStatus } from 'core/ovations-api/enums';

import { dateTimeCurrent } from 'core/util/datetime';

export const mockClaim: OvationsApi.Types.Claim = {
    id: '',
    number: 0,
    submissionDate: dateTimeCurrent(),
    isMailIn: false,
    status: ClaimStatus.PendingValidation,
    reasonId: null,
    systemReason: null,
    customerId: '',
    promotionId: '',
    answers: {},
    notes: '',
    isForPrefund: false,
    reconciliationSubmissionDate: dateTimeCurrent(),
    reconciliationStatus: ReconciliationStatus.PendingSubmission,
    alternatePayee: null,
    hasEsignAgreementAcknowledgement: false,
    rewards: null,
};
